// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1atHj","insightsList":"newBusinessInsightsMenu_insightsList__2fU93","active":"newBusinessInsightsMenu_active__2dUyl"};